import { mdiFileDocumentMultipleOutline } from '@mdi/js'

export default {
  title: 'News',
  to: 'news-hod',
  icon: mdiFileDocumentMultipleOutline,
  action: 'read',
  resource: 'NewsHeadDepartment',
}
